/* (ignored) */


//////////////////
// WEBPACK FOOTER
// min-document (ignored)
// module id = 1
// module chunks = 43